// extracted by mini-css-extract-plugin
export default {"coursePageWrapper":"coursePageStyles_coursePageWrapper__QUN8N"};